





import { getVuxUrlQuery, createRequest } from "../../utils/utils";
import { uploadQiniu, uploadQiniuSetKey } from "../../qiniu/index";
import OnInput from "../oneInput/oneInput.vue";
import TwoInput from "../twoInput/twoInput.vue";
import TheryInput from "../theryInput/theryInput.vue";
import Toast from 'vux/src/components/toast/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import XProgress from 'vux/src/components/x-progress/index.vue'

import { STORAGE_KEY } from "../../utils/define";
import MyVideo from '../myVideo/myVideo.vue';
export default {
uploadingHandler: undefined,
name: "chatframe",
components: {
OnInput,
TwoInput,
TheryInput,
Toast,
XInput,
Selector,
XProgress,
MyVideo,
},
props: {
items: Object,
indexIs: Number,
actionList: Array,
cardTypeIs:String









},
data() {
return {
item: this.items,
addState: false,
inputList: this.items.answer_arr,

oneValue: "",
twoValue: "",
theryValue: "",
index: this.indexIs,
editState: false,
time: new Date(),
showPositionValue: false,
position: "default",
imageUrl: "",
imageKey: "",
editID: 0,
issueValue: "",
list: this.actionList,
value2: "",
actionIdName: "",
pdfNmae: "",
videoUrl: "",
videoCover:"",
setPreinstallState: this.items.is_presets == 1 ? true : false,
uploadProgress: 0,
showVideo:false
};
},
created()
{

},
mounted() {
console.log('%c⧭', 'color: #f27999', this.cardTypeIs,"this.cardTypeIs")
this.getMovement();
console.log(this.item, "-----items");
if (this.item.file_key) {
if (
this.item.file_key.split(".")[
this.item.file_key.split(".").length - 1
] == "pdf"
) {
this.pdfNmae = "PDF文件";
} else if (
this.item.file_key.split(".")[
this.item.file_key.split(".").length - 1
] == "png" ||
this.item.file_key.split(".")[
this.item.file_key.split(".").length - 1
] == "jpg"
) {
this.imageUrl =
this.item.file == null ||
this.item.file == undefined ||
this.item.file == ""
? ""
: this.item.file;
} else if (
this.item.file_key.split(".")[
this.item.file_key.split(".").length - 1
] == "mp4"
) {
this.videoUrl =
this.item.file == null ||
this.item.file == undefined ||
this.item.file == ""
? ""
: this.item.file;
this.videoCover =this.videoUrl + '?vframe/jpg/offset/2/w/480';
}
this.setPreinstallState = this.item.is_presets == 1 ? true : false;
this.imageKey =
this.item.file_key == null ||
this.item.file_key == undefined ||
this.item.file_key == ""
? ""
: this.item.file_key;
}
},
beforeDestroy() {},
methods: {
autoSave(){
console.log('自动保存')
this.saveData()
},

onSetPreinstall() {
this.setPreinstallState = !this.setPreinstallState;
this.autoSave()
},

getMovement() {
let list = this.actionList;

console.log('%c⧭', 'color: #408059', list)
let data = [];
list.forEach((item) => {
let obj = {
value: item.name,
key: item.id,
pic: item.pic,
video: item.video,
gender: item.gender,
};
data.push(obj);
});
this.list = data;
console.log('---list',list)
this.list.forEach((val) => {
console.log("%c⧭", "color: #731d1d;font-size:50px", val.key);
if (val.key == this.item.action_id) {
this.actionIdName = val.value;
}
});
},

getFile(event) {
console.log("get file", event);
let _this = this;
let file = event.target.files[0];
const chars = event.target.files[0].name.split(".");
console.log("%c⧭", "color: #f200e2");
let name = chars[chars.length - 1];
if (["pdf", "png", "jpg", "mp4"].indexOf(name.toLowerCase()) < 0) {
return this.$vux.toast.show({
type: "text",
text: "不支持的文件格式",
});
}
let fileName=event.target.files[0].name.substr(event.target.files[0].name.lastIndexOf('/')+1)
uploadQiniuSetKey(
file,
fileName,
(res) => {
console.log("%c⧭", "color: #00e600", res);
this.uploadProgress = res.percent;
},
(err, res) => {
console.log('上传结束',err,res)
this.uploadProgress = 0;
if (err) {
return this.$vux.toast.show({
type: "text",
text: "上传失败:"+err,
});
}
if (name == "pdf") {
let leng = event.target.files[0].name;
let sp = leng.split('.');

console.log('%c⧭', 'color: #006dcc', sp[0].length)
if(sp[0].length < 6)
{
_this.pdfNmae = event.target.files[0].name;
}
else
{

let ont = sp[0].slice(0,6)
_this.pdfNmae =ont + '.' + sp[sp.length-1];
}
} else if (name == "png" || name == "jpg") {
_this.imageUrl = res.domain + res.key;
} else if (name == "mp4") {
_this.videoUrl = res.domain + res.key;
_this.videoCover = res.domain + res.key+'?vframe/jpg/offset/2/w/480';
}
_this.imageKey = res.key;
_this.autoSave()
}
).then((currentUploadHandler) => {
this.uploadingHandler = currentUploadHandler;
});
console.log("%c⧭", "color: #ff0000");
},

onDelImageUrlKey() {
this.imageKey = "";
this.imageUrl = "";
this.videoUrl="";
this.pdfNmae = "";
this.autoSave()
},
onInput(value) {
console.log("%c⧭", "color: #997326", value);
this.oneValue = value;
},

onDelOneInput(event) {
if (this.inputList.length == 1) {
this.showPositionValue = true;
} else if (event == 0) {
this.inputList.splice(event, 1);
console.log("%c⧭", "color: #f27999", this.inputList);
this.oneValue = this.twoValue; 
this.twoValue = this.theryValue;
console.log("%c⧭", "color: #40fff2", this.twoValue);
this.theryValue = "";
this.autoSave()
}

},
onTwoInput(value) {
console.log("%c⧭", "color: #997326", value);
this.twoValue = value;

},

onDelTwoInput(event) {
if (this.inputList.length == 1) {
this.showPositionValue = true;
} else if (event == 1) {
this.inputList.splice(event, 1);
this.twoValue = this.theryValue; 
this.theryValue = "";
this.autoSave()
}

},
onTheryInput(value) {
console.log("%c⧭", "color: #997326", value);
this.theryValue = value;
},

onDelThrryInput(event) {
if (this.inputList.length == 1) {
this.showPositionValue = true;
} else if (event == 2) {
this.inputList.splice(event, 1);
this.theryValue = "";
this.autoSave()
}

},
onEdit(val) {
this.value2 = this.item.action_id;
this.issueValue = this.item.question;
this.editID = val;
this.editState = true;
},
saveData(){
return new Promise((resolve,reject)=>{
let data = [];

this.oneValu != "" && data.push(this.oneValue);
this.twoValue != "" && data.push(this.twoValue);
this.theryValue != "" && data.push(this.theryValue);
this.inputList = data;
createRequest(
"post",
"applet/webview/qa/update",
{
image_id:this.cardTypeIs == '3d' ? localStorage.getItem(STORAGE_KEY.MODEL_ID) : '',
id: this.editID,
action_id: this.value2,
question: this.issueValue,
answer: this.inputList,
file: this.imageKey,
is_presets: this.setPreinstallState ? 1 : 2,
card_id:this.cardTypeIs == '2d' ? localStorage.getItem(STORAGE_KEY.MODEL_ID) : '',
},
(res) => {
console.log("%c⧭", "color: #d90000", res);
if (res.code == 200) {
return resolve(res)
} else {
console.error(res.msg);
return reject(res.msg)
}
}
);
})
},
onSave(val) {
this.saveData().then(d=>{
this.$vux.toast.show({
type: "text",
text: "保存成功",
});
this.editState = false;
this.list.forEach((val) => {
console.log("%c⧭", "color: #731d1d;font-size:50px", val.key);
if (val.key == this.value2) {
this.actionIdName = val.value;
}
});
this.$emit("onSaveGetList", true);
},e=>{
this.$vux.toast.show({
type: "text",
text:e,
});
})
},
onDelect(val, i) {
console.log("%c⧭", "color: #cc0088", val, i);
if (this.editState) {

this.editState = false;
} else {

this.$emit("onDelectVal", val, i);
}
},
addInput(item) {
this.inputList.push("");
},
cancelUpload() {
console.log("cancel upload");
this.uploadingHandler && this.uploadingHandler.unsubscribe();
this.uploadProgress = 0;
},
onLookVideo(){
console.log('look video')
if(this.showVideo){
this.showVideo=false
}
this.showVideo=true
},
onHideMyVideo(){
console.log('video 隐藏')
this.showVideo=false
}
},
watch: {
items(value) {
console.log("%c⧭", "color: #bfffc8", value);
this.item = value;
},
issueValue(value) {
this.issueValue = value;
},
actionList(value){
this.actionList=value
this.getMovement()
}
},
};



// WEBPACK FOOTER //
// ./src/myComponents/edit/edit.vue